var map = {
	"./imag1.png": "109b",
	"./imag2.png": "40d8",
	"./miniatura.svg": "334d",
	"./send-template.png": "ec43",
	"./template-img.svg": "89b2",
	"./template1.svg": "8fa3",
	"./template2.svg": "777d",
	"./template3.svg": "776a",
	"./template4.svg": "e8d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9eff";